export default "__VITE_ASSET__2pEvJ1A0__"